/* ZINKE — Produktbilder im Vollbild mit Zoom (Theme 4.4, 19.09.2026)
   Pascal: „Die Bilder sind abgeschnitten und ich kann nicht reinzoomen.“

   - Tipp/Klick auf das Hauptbild öffnet alle Produktbilder im Vollbild
     (dunkler Grund, Reihenfolge wie in der Galerie, Start beim aktuellen Bild).
   - Wischen oder Pfeile blättern, der Zähler zeigt „3 / 11“.
   - Tipp auf ein Bild vergrößert es 2,5× an der getippten Stelle, danach mit
     dem Finger verschieben; nochmal tippen = zurück. Zwei-Finger-Zoom geht
     zusätzlich (Browser).
   - Schließen: X, Esc, Tipp neben das Bild (4.6) oder die Zurück-Taste des Handys (eigener Verlaufs-
     eintrag, damit „Zurück“ nicht die Seite verlässt).
   Die Bilder kommen in 2000 px aus dem Shopify-CDN und laden erst beim Öffnen.
   Beschriftungen (Schließen, Vor, Zurück) liefert main-product.liquid als
   data-Attribute in der Shopsprache. */
(() => {
  'use strict';

  const X = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M5 5l14 14M19 5L5 19" stroke="currentColor" stroke-width="1.8" fill="none" stroke-linecap="round"/></svg>';
  const PFEIL = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M6 9l6 6 6-6" stroke="currentColor" stroke-width="1.8" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  let offen = null;

  function gross(src) {
    if (!src) return '';
    return /[?&]width=\d+/.test(src) ? src.replace(/([?&]width=)\d+/, '$12000') : src + (src.indexOf('?') < 0 ? '?' : '&') + 'width=2000';
  }

  function bilderLesen(wurzel) {
    const medien = Array.from(wurzel.querySelectorAll('.product-main-media[data-media-id]'));
    const nachId = {};
    medien.forEach(m => { nachId[m.dataset.mediaId] = m; });
    // Reihenfolge wie die (ggf. umsortierte) Bildleiste, sonst DOM-Reihenfolge
    const knoepfe = Array.from(wurzel.querySelectorAll('[data-thumbnail]'));
    const folge = knoepfe.length ? knoepfe.map(k => nachId[k.dataset.thumbnail]).filter(Boolean) : medien;
    return folge.map(m => {
      const img = m.querySelector('img');
      return img ? { id: m.dataset.mediaId, src: gross(img.getAttribute('src')), alt: img.alt || '' } : null;
    }).filter(Boolean);
  }

  function zaehler(v) {
    const i = Math.round(v.spur.scrollLeft / Math.max(1, v.spur.clientWidth));
    v.index = Math.min(v.bilder.length - 1, Math.max(0, i));
    v.zaehler.textContent = (v.index + 1) + ' / ' + v.bilder.length;
    // Nachbarbilder vorladen
    [v.index - 1, v.index, v.index + 1].forEach(n => {
      const img = v.seiten[n] && v.seiten[n].querySelector('img');
      if (img && !img.getAttribute('src')) img.setAttribute('src', img.dataset.src);
    });
  }

  function gehe(v, n, sanft) {
    n = Math.max(0, Math.min(v.bilder.length - 1, n));
    v.seiten.forEach(s => s.classList.remove('ist-gross'));
    v.spur.scrollTo({ left: n * v.spur.clientWidth, behavior: sanft ? 'smooth' : 'auto' });
    setTimeout(() => zaehler(v), sanft ? 350 : 0);
  }

  function schliessen(ausVerlauf) {
    if (!offen) return;
    const v = offen;
    offen = null;
    v.el.classList.remove('ist-offen');
    document.documentElement.classList.remove('z-zoom-offen');
    document.removeEventListener('keydown', v.tasten);
    window.removeEventListener('popstate', v.zurueck);
    setTimeout(() => v.el.remove(), 250);
    if (v.vorher && v.vorher.focus) v.vorher.focus({ preventScroll: true });
    if (!ausVerlauf && history.state && history.state.zinkeZoom) history.back();
  }

  function oeffnen(wurzel, startId) {
    if (offen) return;
    const bilder = bilderLesen(wurzel);
    if (!bilder.length) return;
    const galerie = wurzel.querySelector('[data-gallery]') || wurzel;
    const t = {
      zu: galerie.dataset.zoomZu || 'Schließen',
      vor: galerie.dataset.zoomVor || 'Nächstes Bild',
      zurueck: galerie.dataset.zoomZurueck || 'Vorheriges Bild',
      hinweis: galerie.dataset.zoomHinweis || ''
    };
    const el = document.createElement('div');
    el.className = 'z-zoom';
    el.setAttribute('role', 'dialog');
    el.setAttribute('aria-modal', 'true');
    el.innerHTML =
      '<button type="button" class="z-zoom-zu" data-z-zoom-zu aria-label="' + t.zu + '">' + X + '</button>' +
      '<div class="z-zoom-spur" data-z-zoom-spur></div>' +
      (t.hinweis ? '<p class="z-zoom-hinweis" data-z-zoom-hinweis>' + t.hinweis + '</p>' : '') +
      '<div class="z-zoom-leiste">' +
        (bilder.length > 1 ? '<button type="button" class="z-zoom-pfeil" data-z-zoom-zurueck aria-label="' + t.zurueck + '">' + PFEIL + '</button>' : '') +
        '<span data-z-zoom-zaehler aria-live="polite"></span>' +
        (bilder.length > 1 ? '<button type="button" class="z-zoom-pfeil" data-z-zoom-vor aria-label="' + t.vor + '">' + PFEIL + '</button>' : '') +
      '</div>';
    const spur = el.querySelector('[data-z-zoom-spur]');
    bilder.forEach(b => {
      const seite = document.createElement('div');
      seite.className = 'z-zoom-seite';
      const img = document.createElement('img');
      img.dataset.src = b.src;
      img.alt = b.alt;
      img.decoding = 'async';
      seite.appendChild(img);
      spur.appendChild(seite);
    });
    document.body.appendChild(el);
    document.documentElement.classList.add('z-zoom-offen');

    const v = {
      el, spur, bilder, index: 0,
      seiten: Array.from(spur.children),
      zaehler: el.querySelector('[data-z-zoom-zaehler]'),
      vorher: document.activeElement
    };
    let start = Math.max(0, bilder.findIndex(b => b.id === String(startId)));
    v.index = start;
    v.seiten[start].querySelector('img').setAttribute('src', bilder[start].src);

    v.tasten = e => {
      if (e.key === 'Escape') { e.preventDefault(); schliessen(); }
      else if (e.key === 'ArrowRight') gehe(v, v.index + 1, true);
      else if (e.key === 'ArrowLeft') gehe(v, v.index - 1, true);
    };
    v.zurueck = () => schliessen(true);
    document.addEventListener('keydown', v.tasten);
    try { history.pushState({ zinkeZoom: 1 }, ''); window.addEventListener('popstate', v.zurueck); } catch (e) {}

    let takt = null;
    spur.addEventListener('scroll', () => { clearTimeout(takt); takt = setTimeout(() => zaehler(v), 80); }, { passive: true });

    el.addEventListener('click', e => {
      if (e.target.closest('[data-z-zoom-zu]')) { schliessen(); return; }
      if (e.target.closest('[data-z-zoom-vor]')) { gehe(v, v.index + 1, true); return; }
      if (e.target.closest('[data-z-zoom-zurueck]')) { gehe(v, v.index - 1, true); return; }
      const img = e.target.closest('.z-zoom-seite img');
      // 4.6: Tipp neben das Bild (dunkle Fläche) schließt die Ansicht.
      if (!img) {
        if (e.target.closest('.z-zoom-seite, .z-zoom-spur') || e.target === el) schliessen();
        return;
      }
      const seite = img.parentElement;
      const hinweis = el.querySelector('[data-z-zoom-hinweis]');
      if (hinweis) hinweis.classList.add('ist-weg');
      if (seite.classList.contains('ist-gross')) { seite.classList.remove('ist-gross'); return; }
      const r = img.getBoundingClientRect();
      const fx = (e.clientX - r.left) / Math.max(1, r.width);
      const fy = (e.clientY - r.top) / Math.max(1, r.height);
      seite.classList.add('ist-gross');
      requestAnimationFrame(() => {
        seite.scrollLeft = fx * img.offsetWidth - seite.clientWidth / 2;
        seite.scrollTop = fy * img.offsetHeight - seite.clientHeight / 2;
      });
    });

    offen = v;
    requestAnimationFrame(() => {
      spur.scrollLeft = start * spur.clientWidth;
      zaehler(v);
      el.classList.add('ist-offen');
      el.querySelector('[data-z-zoom-zu]').focus({ preventScroll: true });
    });
    const hinweis = el.querySelector('[data-z-zoom-hinweis]');
    if (hinweis) setTimeout(() => hinweis.classList.add('ist-weg'), 2600);
  }

  document.addEventListener('click', e => {
    const img = e.target.closest('[data-product-root] .product-main-media img');
    if (!img) return;
    const wurzel = img.closest('[data-product-root]');
    const medium = img.closest('.product-main-media');
    e.preventDefault();
    oeffnen(wurzel, medium && medium.dataset.mediaId);
  });
})();
